module.exports = __webpack_public_path__ + "7fe9f7985a00700abd93008f6907b411.svg";